import { buildClasses } from "../utils/buildClasses";

export function TransactionColumnSpacer() {
  // Narrow by default, widening into spare room up to 20px on wide screens,
  // and giving up its space well before the columns do when room is short.
  // The cells' own padding still keeps their contents apart.
  return (
    <div
      className={buildClasses("w-2", "max-w-5", "grow-[0.1]", "shrink-[4]")}
    />
  );
}
